import styled from '@emotion/styled';

import { primaryColor } from '@zego/theme';

const Emphasis = styled.span({
  color: primaryColor(9),
  fontWeight: 700,
});

export default Emphasis;
